// client/src/utils/quotationItemNameAfterPick.ts
//
// THE NAME A QUOTATION LINE KEEPS AFTER A PICK PRICES IT.
//
// United Ship Chandlers, 2026-09-22 (JP and Deborah, client call): "I don't
// want to replace the vessel's item description. I just want to replace the
// price" / "Sometimes these people have their own description … we try not
// to change their item name because they're familiar with it that way." The
// answer is the same on every writer that can replace a line's whole price:
// the vessel's own wording survives whenever the line states one, and only a
// line added blank — nothing to protect — takes the picked option's own name.
//
// Born as `cataloguePickDetails.itemNameAfterCataloguePick` (client-only,
// 2026-09-22), for the quotation page's catalogue-search pick
// (`QuotationDetailPage.handleSearchSelect`). Owner audit, 2026-09-25: the
// merged catalogue+supplier lookup panel's SUPPLIER pick
// (`quotationLineSupplierPrice.resolveListedSupplierPick`, server) can name a
// genuinely different product too, not only a different vendor for the same
// goods (F1), and it needs the identical answer — so this moved here to be
// the one owner both writers call, rather than the server growing its own
// second copy of a two-line function. `cataloguePickDetails
// .itemNameAfterCataloguePick` is now a thin wrapper around this.
//
// MIRRORED FILE: src/utils/quotationItemNameAfterPick.js is a line-for-line
// twin. CRA's ModuleScopePlugin forbids importing from src/, so the copy is
// the only option. Change one, change both — mirroredUtilParity.test.js fails
// if you do not.

export function itemNameAfterProductPick({
  currentName,
  pickedName,
}: {
  /** The line's own name before the pick, exactly as it is stored. */
  currentName: string | null | undefined;
  /** The picked option's own name. */
  pickedName: string | null | undefined;
}): string {
  if (typeof currentName === 'string' && currentName.trim()) return currentName;
  return typeof pickedName === 'string' ? pickedName.trim() : '';
}
